import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type { UpdateWarehouseInput, WarehouseSummary } from '@erp/rpc';
import { useToast } from '@/context/ToastContext';

export function useUpdateWarehouse(onSuccess?: () => void) {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation<WarehouseSummary, Error, UpdateWarehouseInput>({
    mutationFn: (input) =>
      rpcClient.inventoryManagement.warehouses.update(input),
    onSuccess: () => {
      showToast({
        title: 'Warehouse updated',
        message: 'Warehouse changes saved.',
        color: 'success',
        icon: 'check',
      });
      void queryClient.invalidateQueries({
        queryKey: orpc.inventoryManagement.warehouses.list.queryKey({
          input: {},
        }),
      });
      onSuccess?.();
    },
    onError: (error) => {
      showToast({
        title: 'Error',
        message: error.message || 'Failed to update warehouse',
        color: 'error',
        icon: 'x',
      });
    },
  });
}
